const list = {
  noMoreResults: false,
  shouldReset: true,
  loading: false,
  pagination: 0,
  query: null,
  results: [],
}

export const state = () => ({
  figures: { ...list },
  videos: { ...list },
  photos: { ...list },
  icons: { ...list },
})

export const mutations = {
  setQuery(state, { scope, query }) {
    state[scope].query = query
  },

  addResults(state, { scope, results }) {
    state[scope].results = [...state[scope].results, ...results]
  },

  setPagination(state, { scope, page }) {
    state[scope].pagination = page
  },

  setLoading(state, { scope, loading }) {
    state[scope].loading = loading
  },

  setNoMoreResults(state, { scope, value }) {
    state[scope].noMoreResults = value
  },

  shouldReset(state, { scope, reset }) {
    state[scope].shouldReset = reset
  },

  reset(state, scope) {
    state[scope].noMoreResults = false
    state[scope].pagination = 0
    state[scope].results = []
  },
}

export const actions = {
  /**
   * Sets the scoped query and tells the search to reset.
   */
  async setQuery({ commit }, { scope, query }) {
    commit('shouldReset', { scope, reset: true })
    commit('setQuery', { scope, query })
  },

  /**
   * Reset the current page and results.
   */
  async reset({ commit }, scope) {
    commit('reset', scope)
  },

  /**
   * Fetch stock photos.
   */
  async searchPhotos({ dispatch, commit, state }) {
    const url = '/api/v3/assets/stock/photos/search'
    const scope = 'photos'
    let results = []

    commit('setLoading', { scope, loading: true })

    if (state[scope].shouldReset) {
      await dispatch('reset', scope)
    }

    commit('shouldReset', { scope, reset: false })

    const page = state[scope].pagination + 1

    try {
      const params = { query: state.photos.query, per_page: 50, page }
      const { data } = await this.$api.get(url, { params })

      results = data.results

      commit('addResults', { scope, results })
      commit('setPagination', { scope, page })
    } catch (error) {
      this.$sentry.captureException(error)
      this.$toast.error(
        `There was an error loading your ${scope}, please refresh and try again.`
      )
    } finally {
      commit('setLoading', { scope, loading: false })
    }

    return results || []
  },

  /**
   * Fetch stock icons.
   */
  async searchIcons({ dispatch, commit, state }) {
    const keywords = state.icons?.query?.trim() || ''
    const url = `/api/v3/assets/icons/keywords/${keywords}`
    const scope = 'icons'
    let results = []

    commit('setLoading', { scope, loading: true })

    if (state[scope].shouldReset) {
      await dispatch('reset', scope)
    }

    commit('shouldReset', { scope, reset: false })

    // After resetting skip early if we don't have any more results to show
    if (state[scope].noMoreResults) {
      commit('setLoading', { scope, loading: false })

      return results
    }

    const cursor = state[scope].pagination

    try {
      const params = { cursor, limit: 12 }
      const { data } = await this.$api.get(url, { params })

      results = data.icons

      if (data.next_cursor === 0) {
        commit('setNoMoreResults', { scope, value: true })
      }

      commit('addResults', { scope, results })
      commit('setPagination', { scope, page: data.next_cursor })
    } catch (error) {
      if (error?.message?.includes('No icons found')) {
        // Throw away fake error 👋🏻
        return results || []
      }

      this.$sentry.captureException(error)

      this.$toast.error(
        `There was an error loading your ${scope}, please refresh and try again.`
      )
    } finally {
      commit('setLoading', { scope, loading: false })
    }

    return results || []
  },
}
